<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getBank, add, del, update, getDetails } from "@/api/finance/bank";
import cTable from "@/base/common/index";
import { getCompanies } from "@/api/user/client";
export default {
  name: "bankInfo",
  components: {
    cTable,
  },
  data() {
    let options = [
      { label: this.$t("bank1"), value: "bank" },
      { label: this.$t("alipay"), value: "alipay" },
      { label: this.$t("wechat"), value: "wechat" },
    ];
    return {
      methods: {
        list: getBank,
        getDetails,
        del,
        add,
        update,
        getCompanies,
        beforeHandleList({ data }) {
          return data;
        },
      },
      footer: {
        show: () => false,
      },
      config: {
        height: 630,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              ownership: [
                {
                  required: true,
                  message: "account_type cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              account_type: [
                {
                  required: true,
                  message: "account_type cannot be empty",
                  trigger: "blur",
                },
              ],
              bank_name: [
                {
                  required: true,
                  message: "bank_name cannot be empty",
                  trigger: "blur",
                },
              ],
              zipcode: [
                {
                  required: true,
                  message: "zip_code cannot be empty",
                  trigger: "blur",
                },
              ],
              bank_code: [
                {
                  required: true,
                  message: "bank_code cannot be empty",
                  trigger: "blur",
                },
              ],
              bank_account: [
                {
                  required: true,
                  message: "bank_account cannot be empty",
                  trigger: "blur",
                },
              ],
              sort: [
                {
                  required: true,
                  type: "number",
                  message: "sort cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { ownership: 24 },
            { account_type: 24 },
            { bank_name: 24 },
            { bank_code: 24 },
            { bank_account: 24 },
            { b_type: 24 },
            { sort: 24 },
          ],
          fields: [
            {
              name: () => this.$t("ownership"),
              key: "ownership",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("ownership");
              },
              options: [],
              config: { label: "title", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCompanies")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: () => this.$t("account_type"),
              key: "account_type",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("account_type");
              },
            },
            {
              name: () => this.$t("bank_name"),
              key: "bank_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bank_name");
              },
            },
            {
              name: () => this.$t("bank_code"),
              key: "bank_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bank_code");
              },
            },
            {
              name: () => this.$t("bank_account"),
              key: "bank_account",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bank_account");
              },
            },
            {
              name: () => this.$t("pay") + this.$t("type"),
              key: "b_type",
              component: "Radio",
              options: options,
              bind: {
                border: true,
              },
              default: "bank",
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
              bind: {
                step: 1,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            name: () => this.$t("ownership"),
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            options: [],
            config: { label: "title", value: "id" },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getCompanies")
                ).payload;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 310,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
          align: "left",
        },
        {
          name: () => this.$t("createUser"),
          key: "operator_name",
          width: 130,
          align: "left",
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
        },
        {
          name: () => this.$t("account_type"),
          key: "account_type",
          width: 130,
          align: "left",
        },
        {
          name: () => this.$t("pay") + this.$t("type"),
          key: "b_type",
          align: "left",
          width: 80,
          methods: {
            render({ value }) {
              return options.find((item) => item.value === value).label;
            },
          },
        },
        {
          name: () => this.$t("bank_name"),
          key: "bank_name",
          width: 130,
          align: "left",
        },
        {
          name: () => this.$t("bank_code"),
          key: "bank_code",
          align: "left",
        },
        {
          name: () => this.$t("bank_account"),
          key: "bank_account",
          align: "left",
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          width: "80",
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 311,
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 313,
            },
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
    });
  },
};
</script>
